App.SettingsAnalyticsController = Em.Controller.extend
  organizationBinding: 'model'

  isSaving: false

  imageMetaImageStyle: Em.computed(
    'organization.meta_image'
    ->
      MetaImage = @get('organization.meta_image')

      if MetaImage?
        return "background-color: grey; background-image: url(#{ MetaImage })".htmlSafe()
      else
        return "background-image: url(#{ @get('organization.avatarPlaceholder') })".htmlSafe()
  )

  actions:
    saveOrganization: ->
      @set('isSaving', true)

      @get('organization').save()
      .finally =>
        @set('isSaving', false)
      false

    discartChanges: ->
      @get('organization').rollback()
      false


    openMetaImageFileDialog: ->
      @get('fileMetaImageInput').send('openDialog')
      false

    uploadMetaImage: (file) ->
      @set('fileMetaImageIsUploading', true)
      organization = @get('organization')

      organization.uploadMetaImage(file)
        .then ->
          organization.reload()
        .finally =>
          @set('fileMetaImageIsUploading', false)

      false
